import {
  WSAvatar,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSLoader,
  WSScreen,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useQueryBankingBalance } from "../../query/bookkeeping/queries";

type Props = WSElementProps;

export const MethodWallet: React.FC<Props> = ({ ...elementProps }) => {
  const queryBankingBalanceBalance = useQueryBankingBalance();
  const title = "Wingspan Wallet";
  const description = queryBankingBalanceBalance.data ? (
    `${formatMoney(
      queryBankingBalanceBalance.data.available || 0,
      queryBankingBalanceBalance.data.currency
    )} is available`
  ) : (
    <WSLoader.Spinner size="S" />
  );

  return (
    <WSFlexBox wrap="nowrap" alignItems="center" {...elementProps}>
      <WSAvatar.Icon
        color="white"
        colorBackground="garnet"
        icon="wallet"
        mr="M"
      />

      <WSScreen.Mobile>
        <WSElement>
          <WSText weight="medium" mr="M">
            {title}
          </WSText>
          <WSText.ParagraphSm color="gray500">{description}</WSText.ParagraphSm>
        </WSElement>
      </WSScreen.Mobile>
      <WSScreen.TabletAndDesktop>
        <WSText weight="medium" mr="M">
          {title}
        </WSText>
        <WSText color="gray500">{description}</WSText>
      </WSScreen.TabletAndDesktop>
    </WSFlexBox>
  );
};
